<template>
  <div id="view">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div class="tipTitle">价格设置</div>

      <div class="bannnerLi flex">
        <div class="title">下单价格：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.price" type="number" placeholder="请输入">
            <template slot="append">元</template>
          </el-input>
        </div>
      </div>

      <div class="tipTitle">香遇鉴别仓库</div>
      <div class="bannnerLi flex">
        <div class="title">收货人：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.consignee" type="text" placeholder="请输入">
          </el-input>
        </div>
      </div>
      <div class="bannnerLi flex">
        <div class="title">收货电话：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.phone" type="number" placeholder="请输入">
          </el-input>
        </div>
      </div>
      <div class="bannnerLi flex">
        <div class="title">收货地址：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.address" type="text" placeholder="请输入">
          </el-input>
        </div>
      </div>z

      <div class="tipTitle">香遇寄售仓库</div>
      <div class="bannnerLi flex">
        <div class="title">收货人：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.jsConsignee" type="text" placeholder="请输入">
          </el-input>
        </div>
      </div>
      <div class="bannnerLi flex">
        <div class="title">收货电话：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.jsPhone" type="number" placeholder="请输入">
          </el-input>
        </div>
      </div>
      <div class="bannnerLi flex">
        <div class="title">收货地址：</div>
        <div style="width: 500px" class="flex">
          <el-input v-model="listObj.jsAddress" type="text" placeholder="请输入">
          </el-input>
        </div>
      </div>



      <div class="tipTitle">实物鉴别须知</div>

      <div class="bannnerLi">
        <div class="title">鉴别须知：</div>
        <div style="width: 800px" class="flex">
          <wangEditor :initText="listObj.depict" @myEditorContent="getTxt"></wangEditor>
        </div>
      </div>

      <div class="flex">
        <div class="setLi">
          <div class="tipTitle">产品批次提示</div>

          <div class="bannnerLi">
            <div class="title"></div>
            <div style="width: 240px; height: 140px">
              <elUpload @getImg="getImgFn" :image="listObj.images"></elUpload>
            </div>
          </div>
        </div>

        <div class="setLi" style="margin-left: 50px">
          <div class="tipTitle">鉴别时效提示</div>

          <div class="bannnerLi">
            <div class="title"></div>
            <div style="width: 240px; height: 140px">
              <elUpload @getImg="getIdentifyImgFn" :image="listObj.jbsxts"></elUpload>
            </div>
          </div>
        </div>
      </div>

      <div class="tipTitle">寄售管理员</div>

      <div class="bannnerLi">
        <div class="title"></div>
        <div style="width: 240px; height: 140px">
          <elUpload @getImg="getImgFn2" :image="listObj.jstp"></elUpload>
        </div>
      </div>

      <div class="bannnerLi flex">
        <el-button type="success" :disabled="submitShow" @click="submitFn"
          >保存</el-button
        >
        <!-- <el-button type="info" size="small" @click="returnFn">返回</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import { delTips, isJSON, throttle } from "@/util/utils";
import mapFm from "@/components/mapFm";
import elUpload from "@/components/elUpload";
import wangEditor from "@/components/wangEditor";
export default {
  props: {},
  components: {
    mapFm,
    elUpload,
    wangEditor,
  },
  data() {
    return {
      // 历史记录
      historyArr: ["基本设置"],

      currentPage: 1,
      pageSize: 10,
      pageShow: "add",

      //轮播列表
      submitShow: false,

      // 是否编辑
      isEdit: false,

      // 数据
      listObj: {
        address: "",
        consignee: "",
        depict: "",
        phone: "",
        price: "",
        jspt: "",
        jsConsignee: "",
        jsPhone: "",
        jsAddress: "",
      },
    };
  },

  created() {
    this.selList();
  },
  mounted() {},
  //监听数据
  computed: {},
  methods: {
    // 添加历史
    historyFn(title, str) {
      this.historyArr.push(title);
      this.pageShow = str;
    },

    // 图片上传前
    beforeUpload: function (res) {},

    //获取文本
    getArticleTxt: function (res) {
      this.$set(this.listObj, "depict", res);
    },

    // 图片上传
    getImgFn: function (path) {
      this.$set(this.listObj, "images", path);
    },
    // 图片上传
    getImgFn2: function (path) {
      this.$set(this.listObj, "jstp", path);
    },

    // 鉴别时效图片
    getIdentifyImgFn: function (path) {
      this.$set(this.listObj, "jbsxts", path);
    },

    // 获取富文本
    getTxt: function (res) {
      this.listObj.depict = res;
    },

    // 查询
    selList: function () {
      var urls = this.$api.api.selSet;
      var data = {
        page: 1,
        size: 1,
      };
      this.$https(urls, data, "POST").then((res) => {
        if (res.data.code == 200 && res.data.data.length > 0) {
          let data = res.data.data[0];
          this.listObj = data;
        }
      });
    },

    //提交数据
    submitFn: throttle(function (res) {
      var list = this.listObj;

      if (!list.price) {
        this.$message.error("请输入下单价格");
        return;
      }

      if (!list.consignee) {
        this.$message.error("请输入收货人");
        return;
      }
      if (!list.phone) {
        this.$message.error("请输入收货电话");
        return;
      }
      if (!list.address) {
        this.$message.error("请输入收货地址");
        return;
      }

      if (!list.jsConsignee) {
        this.$message.error("请输入寄售仓库收货人");
        return;
      }
      if (!list.jsPhone) {
        this.$message.error("请输入寄售仓库收货电话");
        return;
      }
      if (!list.jsAddress) {
        this.$message.error("请输入寄售仓库收货地址");
        return;
      }

      if (!list.depict) {
        this.$message.error("请输入鉴别须知");
        return;
      }

      if (!list.images) {
        this.$message.error("请上传产品批次提示");
        return;
      }

      if (!list.jbsxts) {
        this.$message.error("请上传鉴别时效提示");
        return;
      }

      let obj = {
        price: list.price,
        phone: list.phone,
        address: list.address,
        consignee: list.consignee,
        depict: list.depict,
        images: list.images,
        jstp: list.jstp,
        jbsxts: list.jbsxts,
        jsConsignee: list.jsConsignee,
        jsPhone: list.jsPhone,
        jsAddress: list.jsAddress,
      };

      var urls = "";
      if (list.id) {
        urls = this.$api.api.upSet;
        obj.id = this.listObj.id;
      } else {
        urls = this.$api.api.addSet;
      }

      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.selList();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    closeFn: function () {
      this.excellenShow = 0;
      this.selList(this.currentPage);
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  /* 头部起始位置 */
  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  // 轮播图列表
  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .bannerList {
    width: 100%;
  }

  // 新增图片
  .addBanner {
    width: 100%;
    padding: 5px 20px;
    box-sizing: border-box;
  }

  .tipTitle {
    font-size: 16px;
    line-height: 40px;
    font-weight: bold;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 25px;
    display: flex;

    .title {
      width: 90px;
      line-height: 40px;
      flex-shrink: 0;
    }
  }
}

// 套餐
.setMeal {
  padding-left: 30px;
  box-sizing: border-box;
  margin-bottom: 30px;
}

// 套餐

// 设置为优质卖家
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 300px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;

      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/RechargeAdmin/add.vue